export interface FileValidationRules {
  maxSize: number // bytes
  allowedTypes?: string[] // MIME types (optional - accept all if not provided)
  maxFiles?: number
}

export interface ValidationResult {
  valid: File[]
  errors: string[]
}

const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

export const validateFiles = (
  files: FileList | File[],
  rules: FileValidationRules
): ValidationResult => {
  const valid: File[] = []
  const errors: string[] = []

  const fileArray = Array.from(files)

  // Check file count
  if (rules.maxFiles && fileArray.length > rules.maxFiles) {
    errors.push(`Maximum ${rules.maxFiles} files allowed. You selected ${fileArray.length} files.`)
    return { valid, errors }
  }

  fileArray.forEach((file) => {
    // Size validation
    if (file.size > rules.maxSize) {
      errors.push(
        `${file.name} exceeds maximum size of ${formatBytes(rules.maxSize)} (actual: ${formatBytes(file.size)})`
      )
      return
    }

    // Type validation (if rules specified)
    if (rules.allowedTypes && rules.allowedTypes.length > 0) {
      if (!rules.allowedTypes.includes(file.type)) {
        errors.push(
          `${file.name} has invalid type "${file.type}". Allowed types: ${rules.allowedTypes.join(', ')}`
        )
        return
      }
    }

    // File passed all validations
    valid.push(file)
  })

  return { valid, errors }
}

// Default validation rules
export const DEFAULT_VALIDATION_RULES: FileValidationRules = {
  maxSize: 100 * 1024 * 1024, // 100MB
  maxFiles: 10,
  // No type restrictions by default
}
